function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 311 311"
}, props), React.createElement("rect", {
  width: "311",
  height: "311",
  rx: "40",
  fill: "url(#paint0_linear_3962_3648)"
}), React.createElement("path", {
  d: "M237.191 72.902A114.433 114.433 0 00199.74 47.74 114.507 114.507 0 00155.466 39C91.812 39 39.933 90.843 39.933 154.452c0 20.387 5.362 40.192 15.389 57.667L39 272l61.206-16.077c16.905 9.204 35.908 14.097 55.26 14.097C219.121 270.02 271 218.177 271 154.568c0-30.872-12.008-59.88-33.809-81.666zm-81.725 177.546c-17.254 0-34.158-4.66-48.964-13.398l-3.498-2.097-36.374 9.553 9.677-35.416-2.332-3.611a96.227 96.227 0 01-14.69-51.027c0-52.891 43.136-95.996 96.065-95.996 25.648 0 49.781 10.02 67.851 28.193a95.327 95.327 0 0120.861 31.145 95.275 95.275 0 017.235 36.774c.234 52.891-42.902 95.88-95.831 95.88zm52.696-71.764c-2.915-1.398-17.138-8.388-19.703-9.437-2.681-.932-4.546-1.398-6.528 1.398-1.982 2.913-7.462 9.437-9.094 11.301-1.632 1.98-3.381 2.213-6.295.699-2.915-1.398-12.242-4.544-23.2-14.33-8.627-7.689-14.34-17.125-16.089-20.038-1.632-2.912-.233-4.427 1.283-5.941 1.282-1.282 2.914-3.379 4.313-5.01 1.399-1.631 1.982-2.912 2.915-4.776.932-1.981.466-3.612-.233-5.01-.7-1.398-6.529-15.611-8.861-21.436-2.331-5.591-4.78-4.892-6.528-5.009h-5.596c-1.982 0-5.013.699-7.695 3.611-2.565 2.913-10.026 9.903-10.026 24.116s10.376 27.96 11.775 29.824c1.399 1.98 20.402 31.105 49.315 43.571 6.878 3.029 12.241 4.776 16.438 6.058 6.878 2.213 13.174 1.864 18.187 1.165 5.596-.816 17.137-6.99 19.469-13.747 2.448-6.757 2.448-12.466 1.632-13.747-.816-1.282-2.565-1.864-5.479-3.262z",
  fill: "#fff"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_3962_3648",
  x1: "155.5",
  y1: "0",
  x2: "155.5",
  y2: "311",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#01BE3E"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#008832"
})))));